import { RangeButtonGroup } from "./RangeButtonGroup";
import { TimeFrameButtonGroup } from "./TimeFrameButtonGroup";
import { Lang } from "@/data/translation";
import { Range, TimeFrame } from "charts/src/types/chart";

type ControlBarParams = {
  lang: Lang;
  range: Range;
  setRange: (range: Range) => void;
  timeFrame: TimeFrame;
  setTimeFrame: (timeFrame: TimeFrame) => void;
  rangeOptions: Range[];
  timeFrameOptions: TimeFrame[];
};

export const ControlBar = ({
  lang,
  timeFrame,
  setTimeFrame,
  range,
  setRange,
  rangeOptions,
  timeFrameOptions,
}: ControlBarParams) => (
  <div className="flex justify-between gap-x-10 flex-wrap gap-y-2">
    <TimeFrameButtonGroup
      {...{ lang, timeFrame, setTimeFrame, timeFrameOptions }}
    />
    <RangeButtonGroup {...{ range, setRange, rangeOptions }} />
  </div>
);
